import { h, Component } from 'preact';
import cx from 'classnames';
import Markup from 'preact-markup';

import style from './style.less';

import { configure } from '../../../config';
import LinksCluster from '../links-cluster';
import CardHeader from '../../pieces/card-header';
import { fetchAlerts } from '../../../lib/data';

import { TrackingProvider, trackingProvider, trackEvent, INPUT_KEYS, DIMENSION, EVENT } from '@cube/track';
import { Button } from '@cube/blocks';
import callWith from '@os/call-with';

@trackingProvider({
	[DIMENSION.componentpath]: 'SupportCluster'
})
@configure({
	clientDisplayName: 'clientDisplayName'
})
export default class SupportCluster extends Component {

	buttonClick = (alert) => {
		if (!alert.cta_url) return;

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.linkurl]: alert.cta_url.href,
			[DIMENSION.text]: 'Alert'
		});

		if (alert.cta_url.open_new_window) {
			return window.open(alert.cta_url.href);
		}
		window.location = alert.cta_url.href;
	};

	getAssets = (props) => {
		if (!props.feed) return;

		return fetchAlerts(props)
			.then( res => {
				if (res.alerts && res.alerts.length > 0) {
					this.setState({
						alerts: res.alerts
					});
					return;
				}
			});
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render({ clientDisplayName, titleLink, links, shuffle, layout, clusterClass, qeId, ...props }, { alerts }) {
		if (!alerts && !links) return null;

		return (
			<div class={cx(style.supportCluster, clusterClass)} qid={qeId}>
				<CardHeader title={`${clientDisplayName} Support`} qeId={qeId} theme="dark" link={titleLink} />
				<div class={style.alerts}>
					{ alerts && alerts.map((alert, i) => (
						<TrackingProvider {...{
							[DIMENSION.clickindex]: i+1
						}}
						>
							<div class={cx(style.message, style[layout])}>
								<div class={style.title}>
									<Markup markup={alert.alert_text} type="html" trim={false} />
								</div>
								{ alert.cta_text && alert.cta_url &&
									<div class={style.controls}>
										<Button onClick={callWith(this.buttonClick, alert)} class={style.button}>{alert.cta_text}</Button>
									</div>
								}
							</div>
						</TrackingProvider>
					)) }
				</div>
				{links &&
					<LinksCluster
						title={null}
						mode="colorful"
						items={links}
						shuffle={shuffle}
						layout={layout}
						qeId="sc-home-links"
						{...props}
					/>
				}
			</div>
		);
	}
}
